import { Label } from '@/components/ui/label';
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle
} from '@/components/ui/card';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue
} from '@/components/ui/select';
import { Separator } from '@/components/ui/separator';
import { Switch } from '@/components/ui/switch';
import { useTheme } from '@/components/theme/theme-provider';

/** Appearance settings: theme plus placeholder preference toggles. */
export function SettingsAppearancePage() {
  const { theme, setTheme } = useTheme();

  return (
    <Card>
      <CardHeader>
        <CardTitle>Appearance</CardTitle>
        <CardDescription>Theme preference is stored locally per browser.</CardDescription>
      </CardHeader>
      <CardContent className="grid gap-6 sm:max-w-md">
        <div className="grid gap-2">
          <Label htmlFor="theme-select">Theme</Label>
          <Select value={theme} onValueChange={(value) => setTheme(value as typeof theme)}>
            <SelectTrigger id="theme-select" className="w-full">
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="light">Light</SelectItem>
              <SelectItem value="dark">Dark</SelectItem>
              <SelectItem value="system">System</SelectItem>
            </SelectContent>
          </Select>
        </div>
        <Separator />
        <div className="flex items-center justify-between">
          <div className="space-y-0.5">
            <Label htmlFor="reduced-motion">Reduce motion</Label>
            <p className="text-muted-foreground text-sm">
              Placeholder toggle for future preferences.
            </p>
          </div>
          <Switch id="reduced-motion" />
        </div>
        <div className="flex items-center justify-between">
          <div className="space-y-0.5">
            <Label htmlFor="compact-mode">Compact tables</Label>
            <p className="text-muted-foreground text-sm">
              Placeholder toggle for future preferences.
            </p>
          </div>
          <Switch id="compact-mode" />
        </div>
      </CardContent>
    </Card>
  );
}
